// grafana的登录页面
<template>
    <div class="grafanaAnalog mainWrap" >
        <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);" >
            <!-- 左边导航栏 -->
            <el-aside style="width:auto;">
                <leftNav msg="/grafanaAnalog"></leftNav>
            </el-aside>
            <!-- 右侧主体部分 -->
            <el-container>
                <el-main>
                    <div class="mainWrao">
                        <iframe :src="ifreamUrl" frameborder="0" style="width:100%;min-height:90vh;" ></iframe>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import { Loading } from "element-ui";
import leftNav from "@/components/nav.vue"
export default {
  name: "login",
  components: {
      leftNav
  },
  data() {
    return {
      // grafana跳转过来时传过来的数据
      access_type: "",
      client_id: "",
      redirect_uri: "",
      response_type: "",
      scope: "",
      state: "",
      ifreamUrl:''
    };
  },
  mounted() {
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true;
      this.$parent.reload();
    } else {
      this.access_type = this.$route.query.access_type;
      this.client_id = this.$route.query.client_id;
      this.redirect_uri = this.$route.query.redirect_uri;
      this.response_type = this.$route.query.response_type;
      this.scope = this.$route.query.scope;
      this.state = this.$route.query.state;
      this.submitForm();
    }
  },
  methods: {
    submitForm() {
      let _this = this;
      let loadingInstance = Loading.service({ fullscreen: true });
      this.axios({
        method: "post",
        url: "/url/oauth/authorize",
        params: {
          client_id: _this.client_id,
          redirect_uri: _this.redirect_uri,
          response_type: _this.response_type,
          scope: _this.scope,
          state: _this.state,
        },
      }).then(function (res) {
        console.log(res.data.redirect_uri +
          "?code=" +
          res.data.code +
          "&state=" +
          res.data.state + "&kiosk=tv")
        _this.ifreamUrl=res.data.redirect_uri +
          "?code=" +
          res.data.code +
          "&state=" +
          res.data.state + "&kiosk=tv"
        // window.location.href =
        //   res.data.redirect_uri +
        //   "?code=" +
        //   res.data.code +
        //   "&state=" +
        //   res.data.state;
        loadingInstance.close();
      });
    },
  },
};
</script>

